import { DropdownOption } from "@components/library/Dropdowns/DropdownOption";
import { getCompaniesForOnboarding } from "@requests/companies";
import { useEffect, useState } from "react";

function useCompanyOptions(): [DropdownOption[]] {
  const [companyOptions, setCompanyOptions] = useState<DropdownOption[]>([]);

  useEffect(() => {
    (async () => {
      const { companies } = await getCompaniesForOnboarding();

      setCompanyOptions(
        companies.map((company) => ({
          value: String(company.id),
          label: company.company_name,
        })) as DropdownOption[]
      );
    })();
  }, []);

  return [companyOptions];
}

export default useCompanyOptions;
